export default __webpack_public_path__ + "static/media/edo.3aae903d.svg";